export const SUPPORTED_LOCALES = ["en", "nl", "ru", "tr", "zh", "pt", "fr", "es"] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const defaultLocale: Locale = "en";

export interface LocaleDisplay {
  flag: string;
  endonym: string;
  /** Goes into the <html lang="..."> attribute. */
  htmlLang: string;
  /** BCP-47 tag for Intl APIs and the grader's `selectedLanguage` field. */
  bcp47: string;
}

export const LOCALE_DISPLAY: Record<Locale, LocaleDisplay> = {
  en: { flag: "\u{1F1EC}\u{1F1E7}", endonym: "English",    htmlLang: "en", bcp47: "en-GB" },
  nl: { flag: "\u{1F1F3}\u{1F1F1}", endonym: "Nederlands", htmlLang: "nl", bcp47: "nl-NL" },
  ru: { flag: "\u{1F1F7}\u{1F1FA}", endonym: "Русский",    htmlLang: "ru", bcp47: "ru-RU" },
  tr: { flag: "\u{1F1F9}\u{1F1F7}", endonym: "Türkçe",     htmlLang: "tr", bcp47: "tr-TR" },
  zh: { flag: "\u{1F1E8}\u{1F1F3}", endonym: "中文",         htmlLang: "zh", bcp47: "zh-CN" },
  pt: { flag: "\u{1F1F5}\u{1F1F9}", endonym: "Português",   htmlLang: "pt", bcp47: "pt-PT" },
  fr: { flag: "\u{1F1EB}\u{1F1F7}", endonym: "Français",    htmlLang: "fr", bcp47: "fr-FR" },
  es: { flag: "\u{1F1EA}\u{1F1F8}", endonym: "Español",     htmlLang: "es", bcp47: "es-ES" },
};

export function isSupportedLocale(v: unknown): v is Locale {
  return typeof v === "string" && (SUPPORTED_LOCALES as readonly string[]).includes(v);
}
